import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const styles = (theme) => ({
  root: {
    color: theme.palette.facet.accentBlue,
  },
  checkmark: {
    fontSize: 'small',
    marginLeft: theme.spacing(0.5),
  },
  serviceContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}
);

const AncillaryServicesItem = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const ancillaryServices = householdResource.attr('ancillaryServices');

  if (ancillaryServices?.length === 0) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {ancillaryServices.map(service => (
        <div className={classes.serviceContainer}>
          <Typography variant="h6">
            {householdResource.meta().field('ancillaryServices').option(service).attr('prompt')}
          </Typography>
          <CheckCircleIcon className={classes.checkmark} />
        </div>
      ))}
    </Box>
  );
};

AncillaryServicesItem.defaultProps = {
  className: '',
};

AncillaryServicesItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AncillaryServicesItem);
